import { Dispatcher2txct93ff9b99 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/DeletePinCommand.mjs';
import { Dispatcher3r3trxa1ofgr6 as Dispatcher_0 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/DeleteSecretCommand.mjs';
import { Dispatcher39hthxqv8voqz as Dispatcher_1 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/SavePlayerCommand.mjs';
import { Dispatcher1dgi8c7arrsv1 as Dispatcher_2 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/DeletePlayerCommand.mjs';
import { Dispatcher27uwezb7p8fpg as Dispatcher_3 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantDiscordAccessCommand.mjs';
import { Dispatcherb76d0p5pxiow as Dispatcher_4 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/SavePinCommand.mjs';
import { Dispatcher3ngwv5mtnm33a as Dispatcher_5 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/ApplyBoostCommand.mjs';
import { Dispatchernmy2not8m2c7 as Dispatcher_6 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/SavePairAssignmentsCommand.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher_7 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { Dispatcher2k7js8ct0qtp5 as Dispatcher_8 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/DeletePairAssignmentsCommand.mjs';
import { Dispatchernurlbopdkn3a as Dispatcher_9 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/SpinCommand.mjs';
import { Dispatcher1zt6xwq01e9iu as Dispatcher_10 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/BeginDiscordOAuthCommand.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher_11 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { Dispatcher2jh9je6zwmtr7 as Dispatcher_12 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/DeletePartyCommand.mjs';
import { Dispatchervu4hb3oerxrm as Dispatcher_13 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantSlackAccessCommand.mjs';
import { Dispatcher3kdydho2ojhnk as Dispatcher_14 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SaveSlackIntegrationCommand.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientDispatcherClass;
function ClientDispatcher() {
  if (ClientDispatcherClass === VOID) {
    class $ {
      constructor(sdkDispatcher) {
        this.f7o_1 = sdkDispatcher;
      }
      *x2i(command, $completion) {
        return yield* this.f7o_1.x2i(command, $completion);
      }
      *w2k(command, $completion) {
        return yield* this.f7o_1.w2k(command, $completion);
      }
      *s2j(command, $completion) {
        return yield* this.f7o_1.s2j(command, $completion);
      }
      *b2k(command, $completion) {
        return yield* this.f7o_1.b2k(command, $completion);
      }
      *k2k(command, $completion) {
        return yield* this.f7o_1.k2k(command, $completion);
      }
      *q2k(command, $completion) {
        return yield* this.f7o_1.q2k(command, $completion);
      }
      *z2k(command, $completion) {
        return yield* this.f7o_1.z2k(command, $completion);
      }
      *d2j(command, $completion) {
        return yield* this.f7o_1.d2j(command, $completion);
      }
      *a2j(command, $completion) {
        return yield* this.f7o_1.a2j(command, $completion);
      }
      *g2j(command, $completion) {
        return yield* this.f7o_1.g2j(command, $completion);
      }
      *e6y(query, $completion) {
        return yield* this.f7o_1.e6y(query, $completion);
      }
      *y2j(command, $completion) {
        return yield* this.f7o_1.y2j(command, $completion);
      }
      *e2k(command, $completion) {
        return yield* this.f7o_1.e2k(command, $completion);
      }
      *n2k(command, $completion) {
        return yield* this.f7o_1.n2k(command, $completion);
      }
      *t2k(command, $completion) {
        return yield* this.f7o_1.t2k(command, $completion);
      }
      *h2k(command, $completion) {
        return yield* this.f7o_1.h2k(command, $completion);
      }
      *j2j(command, $completion) {
        return yield* this.f7o_1.j2j(command, $completion);
      }
    }
    initMetadataForClass($, 'ClientDispatcher', VOID, VOID, [Dispatcher(), Dispatcher_0(), Dispatcher_1(), Dispatcher_2(), Dispatcher_3(), Dispatcher_4(), Dispatcher_5(), Dispatcher_6(), Dispatcher_7(), Dispatcher_8(), Dispatcher_9(), Dispatcher_10(), Dispatcher_11(), Dispatcher_12(), Dispatcher_13(), Dispatcher_14()], [1]);
    ClientDispatcherClass = $;
  }
  return ClientDispatcherClass;
}
//region block: exports
export {
  ClientDispatcher as ClientDispatcher1p2vginamq4dq,
};
//endregion

//# sourceMappingURL=ClientDispatcher.mjs.map
